export const DIM_TARGET_OPACITY = 0.7;
